import { render, staticRenderFns, recyclableRender, components } from "./laborApplication.vue?vue&type=template&id=4b323986&scoped=true&"
var renderjs
import script from "./laborApplication.vue?vue&type=script&lang=js&"
export * from "./laborApplication.vue?vue&type=script&lang=js&"
import style0 from "./laborApplication.vue?vue&type=style&index=0&lang=css&"
import style1 from "./laborApplication.vue?vue&type=style&index=1&id=4b323986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b323986",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/laborApplication/laborApplication.vue"
export default component.exports